export default function Footer() {
  return (
    <footer className="bg-[#1C1C1E] border-t border-[#2C2C2E]">
      <div className="h-[72px] flex items-center justify-center px-[120px]">
        <div className="text-center">
          <p className="text-sm text-gray-400">
            © 2025 FERAR SH.P.K. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}